import { Component, Input, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { ContextService } from 'src/app/services';
import { ITermsCulture } from '../terms-culture';

@Component({
    selector: 'app-accept-terms',
    templateUrl: './accept-terms.component.html',
    styleUrls: ['./accept-terms.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: AcceptTermsComponent,
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: AcceptTermsComponent,
            multi: true
        }],
    standalone: false
})
export class AcceptTermsComponent implements ControlValueAccessor, Validator, OnChanges {
  @Input() terms: ITermsCulture[] = [];
  value: number[] = [];

  items: ({ isSelected: boolean, url: string } & ITermsCulture)[];

  change: (value: number[]) => void;
  validatorChange: () => void;
  touched: () => void;
  webBaseUrl: string;

  constructor(contextService: ContextService) {
    this.webBaseUrl = contextService.webBaseUrl;
  }

  ngOnChanges(): void {
    this.setItems();
  }

  setItems(): void {
    this.items = this.terms.map(term => ({
      ...term,
      isSelected: this.value.includes(term.id),
      url: `${this.webBaseUrl}/Fiscal/${term.providerId}/Public/ViewTerms/${term.id}`
    }));
    if (this.validatorChange) this.validatorChange();
  }

  writeValue(value: number[]): void {
    this.value = value;
    this.setItems();
  }

  registerOnChange(fn: (value: number[]) => void): void {
    this.change = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.touched = fn;
  }

  registerOnValidatorChange?(fn: () => void): void {
    this.validatorChange = fn;
  }

  validate(): ValidationErrors {
    return !this.items.every(t => t.isSelected) ? { notAllTermsAccepted: true } : null
  }

  onSelect(isChecked: boolean, term: ({ isSelected: boolean } & ITermsCulture)) {
    term.isSelected = isChecked;
    this.value = this.items.filter(t => t.isSelected).map(t => t.id);
    this.change(this.value);
    this.touched();
  }
}
